import { SectionCard } from "./SectionCard";
import styles from "./VideosSection.module.scss";

export function VideosSection() {
  return (
    <SectionCard
      id="videos"
      ariaLabelledby="videos-h"
      title="Video Instructions"
      description="Short, targeted walkthroughs. Click any card to open the video in a new tab."
    >
      <div className={styles.grid}>
        <a
          className={styles.videoCard}
          href="https://vimeo.com/850729654"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Briefpoint in 2 Minutes"
        >
          <div className={styles.thumb}>▶</div>
          <div>
            <h3>Briefpoint in 2 Minutes</h3>
          </div>
        </a>
        <a
          className={styles.videoCard}
          href="https://vimeo.com/726376279"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Getting Started"
        >
          <div className={styles.thumb}>▶</div>
          <div>
            <h3>Getting Started</h3>
          </div>
        </a>
        <a
          className={styles.videoCard}
          href="https://vimeo.com/923865503"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="How to Customize Content"
        >
          <div className={styles.thumb}>▶</div>
          <div>
            <h3>How to Customize Content</h3>
          </div>
        </a>
        <a
          className={styles.videoCard}
          href="https://vimeo.com/923865473"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Filter by Document Type"
        >
          <div className={styles.thumb}>▶</div>
          <div>
            <h3>Filter by Document Type</h3>
          </div>
        </a>
        <a
          className={styles.videoCard}
          href="https://vimeo.com/923865544"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="How to Respond to Discovery"
        >
          <div className={styles.thumb}>▶</div>
          <div>
            <h3>How to Respond to Discovery</h3>
          </div>
        </a>
        <a
          className={styles.videoCard}
          href="https://vimeo.com/949252871"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Collect Responses from Clients"
        >
          <div className={styles.thumb}>▶</div>
          <div>
            <h3>Collect Responses from Clients</h3>
          </div>
        </a>
      </div>
    </SectionCard>
  );
}
